import { ClientChannel, PayModeLevel1, PayModeLevel2, Status } from '@fitness-force/enum';

export const CONSTANTS_DATA = {
  ALL_LANGUAGES: [
    { COUNTRY: 'us', LANG_CODE: 'en', LANG_ABBRE: 'ENGLISH', dir:'ltr' },
    { COUNTRY: 'ar', LANG_CODE: 'ar', LANG_ABBRE: 'ARABIC',dir:'rtl' },
    { COUNTRY: 'sa', LANG_CODE: 'ar-sa', LANG_ABBRE: 'ARABIC',dir:'rtl' },
    { COUNTRY: 'fr', LANG_CODE: 'fr', LANG_ABBRE: 'FRENCH',dir:'ltr' },
    { COUNTRY: 'sp', LANG_CODE: 'sp', LANG_ABBRE: 'SPANISH',dir:'ltr' },
    { COUNTRY: 'gr', LANG_CODE: 'gr', LANG_ABBRE: 'GERMAN',dir:'ltr' },
    { COUNTRY: 'in', LANG_CODE: 'hi', LANG_ABBRE: 'HINDI',dir:'ltr' },
    { COUNTRY: 'us', LANG_CODE: 'fr-ca', LANG_ABBRE: 'CANADA - QUEBEC',dir:'ltr'   },
  ],
  SEARCH_PROVIDERS: [
    { providerName: 'clients', pagination: { count: 4, offset: 0 } },
    { providerName: 'invoices', pagination: { count: 4, offset: 0 } },
    { providerName: 'actions', pagination: { count: 4, offset: 0 } },
    { providerName: 'kbdocs', pagination: { count: 4, offset: 0 } },
  ],
  TABLE_PAGE_INFO: {
    CURRENT_PAGE: 'currentPage',
    TOTAL_ITEMS: 'totalItems',
    TOTAL_PAGE: 'toalPages',
  },
  DOMAIN_INFO: { DOMAIN: 'fitnessforcenxt.com' },
  DEFAULT: { LOGIN_SUCCESS_REDIRECTION: '/crm/sales-pipeline' },
  LOST_DEALS_OTHER_REASONS: [
    { name: 'QUALITY OF FACILITY' },
    { name: 'CLUB LOCATION' },
    { name: 'Hours of operation' },
    { name: 'Fitness Equipment' },
  ],
  CHANNEL_SOURCES: [
    { channel: ClientChannel[ClientChannel.Online], source: ['Facebook', 'Website', 'Instagram', 'Class Pass', 'Gym Pass'], },
    { channel: ClientChannel[ClientChannel.WalkIn], source: ['Hoarding', 'Referral', 'Passing By'], },
    { channel: ClientChannel[ClientChannel.Phone], source: ['Hoarding', 'Website', 'Referral', 'Passing By'], },
    { channel: ClientChannel[ClientChannel.DataEntry], source: ['Pop-up Store', 'Referral'], },
    { channel: ClientChannel[ClientChannel.Other], source: ['Other'], },
  ],
  PREFERENCE: [
    { name: 'Email', code: 'Email', icon: ' fa fa-envelope font-light' },
    { name: 'SMS', code: 'SMS', icon: 'fa fa-comments font-light' },
    { name: 'Phone', code: 'Phone', icon: 'fa fa-phone' },
    { name: 'WhatsApp', code: 'WhatsApp', icon: 'fab fa-whatsapp' },
  ],
  TASKTYPE: [
    // { name: 'Email', icon: ' fa fa-envelope font-light' },
    // { name: 'Sms', icon: 'fa fa-comments font-light' },
    { name: 'Call', icon: 'fa fa-phone' },
    // { name: 'Task', icon: 'fa fa-users' },
    { name: 'Tour', icon: 'fa fa-map-marker-alt' },
  ],
  PAYMENTMODE: {
    IN: [
      {
        id: PayModeLevel2.Cash,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Cash,
        name_primary_language: 'Cash',
        name_secondary_language: 'Cash',
        description_primary_language: 'This is Cash Payment mode',
        description_secondary_language: 'This is Cash Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.Debit,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Card,
        name_primary_language: 'Debit Card',
        name_secondary_language: 'Debit Card',
        description_primary_language: 'This is Debit Card Payment mode',
        description_secondary_language: 'This is Debit Card Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.Credit,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Card,
        name_primary_language: 'Credit Card',
        name_secondary_language: 'Credit Card',
        description_primary_language: 'This is Credit Card Payment mode',
        description_secondary_language: 'This is Credit Card Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.NetBanking,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.NetBanking,
        name_primary_language: 'Net Banking',
        name_secondary_language: 'Net Banking',
        description_primary_language: 'This is Net Banking Payment mode',
        description_secondary_language: 'This is Net Banking Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.UPI,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.UPI,
        name_primary_language: 'UPI',
        name_secondary_language: 'UPI',
        description_primary_language: 'This is UPI Payment mode',
        description_secondary_language: 'This is UPI Payment mode',
        status: Status.InActive,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.ACH,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.ACH,
        name_primary_language: 'AmazonPay',
        name_secondary_language: 'AmazonPay',
        description_primary_language: 'This is AmazonPay Payment mode',
        description_secondary_language: 'This is AmazonPay Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.Cheque,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Cheque,
        name_primary_language: 'Cheque',
        name_secondary_language: 'Cheque',
        description_primary_language: 'This is Cheque Payment mode',
        description_secondary_language: 'This is Cheque Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
    ],
    USA: [
      {
        id: PayModeLevel2.Cash,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Cash,
        name_primary_language: 'Cash',
        name_secondary_language: 'Cash',
        description_primary_language: 'This is Cash Payment mode',
        description_secondary_language: 'This is Cash Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.Debit,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Card,
        name_primary_language: 'Debit Card',
        name_secondary_language: 'Debit Card',
        description_primary_language: 'This is Debit Card Payment mode',
        description_secondary_language: 'This is Debit Card Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.Credit,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Card,
        name_primary_language: 'Credit Card',
        name_secondary_language: 'Credit Card',
        description_primary_language: 'This is Credit Card Payment mode',
        description_secondary_language: 'This is Credit Card Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.NetBanking,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.NetBanking,
        name_primary_language: 'Net Banking',
        name_secondary_language: 'Net Banking',
        description_primary_language: 'This is Net Banking Payment mode',
        description_secondary_language: 'This is Net Banking Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.UPI,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.UPI,
        name_primary_language: 'UPI',
        name_secondary_language: 'UPI',
        description_primary_language: 'This is UPI Payment mode',
        description_secondary_language: 'This is UPI Payment mode',
        status: Status.InActive,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
      {
        id: PayModeLevel2.Cheque,
        tenant_id: 0,
        company_id: 0,
        type: PayModeLevel1.Cheque,
        name_primary_language: 'Cheque',
        name_secondary_language: 'Cheque',
        description_primary_language: 'This is Cheque Payment mode',
        description_secondary_language: 'This is Cheque Payment mode',
        status: Status.Active,
        created_by: 0,
        updated_by: 0,
        created_date: '',
        updated_date: '',
      },
    ],
  },
  MONTHS: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  COLORS: [
    'blue',
    'orange',
    'green',
    'purple',
    'pink',
    'cyan',
    'yellow',
    'indigo',
    'teal',
    'bluegray',
    'gray',
  ],
  PAYMENT_GATEWAY_VENDOR_KEY: {
    RAZORPAY: {
      jsSource: 'https://checkout.razorpay.com/v1/checkout.js',
      partnerKey: 'rzp_test_partner_HmxcRUfoVVuLMO',
      themeColor: '#F37254',
    },
  },

  DAYS: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  TRIALS_TYPE: [
    { name: "Days Based", icon: "fa fa-calendar-times", key: "DaysBased" },
    { name: "Class Based", icon: "fa fa-users", key: "ClassBased" },
    { name: "Appointment Based", icon: "fa fa-user", key: "ApptBased" },
  ],
  PAGE_TYPE:[
    { name: "Member Web", key: "member_web" },
    { name: "Prospect Web", key: "prospect_web" },
    { name: "Member Mobile App", key: "member_membermobileapp" },
    { name: "Prospect Mobile App", key: "prospect_membermobileapp" },
    { name: "Member Staff Mobile App", key: "member_staffmobileapp" },
    { name: "Prospect WebMobile App", key: "prospect_staffmobileapp" },
  ],

  CalendarView : [
    {
      name: 'Month View',
      value: 'month',
      icon: 'assets/img/icons/icon-month-view.svg',
    },
    {
      name: 'Week View',
      value: 'week',
      icon: 'assets/img/icons/icon-week-view.svg',
    },
    {
      name: 'Day View',
      value: 'day',
      icon: 'assets/img/icons/icon-day-view.svg',
    },
    {
      name: 'Agenda View',
      value: 'agenda',
      icon: 'assets/img/icons/icon-agenda-view.svg',
    },
  ],
  CalendarResourceView : [
    { name: 'Schedule', icon: 'fa fa-user-plus', value: 'schedule' },
    { name: 'Trainer', icon: 'fa fa-user', value: 'trainer' },
    { name: 'Studio', icon: 'fa fa-building', value: 'studio' },
  ],
  WAVER_FOLDER_NAME:"waiver",

  SALES_RETURN_REASONS:[
    { name: "Injury or health concerns", key: "Injury or health concerns" },
    { name: "Equipment malfunction", key: "Equipment malfunction" },
    { name: "Facility cleanliness or maintenance", key: "Facility cleanliness or maintenance" },
    { name: "Cancellation of membership", key: "Cancellation of membership" },
    { name: "Unsatisfactory results", key: "Unsatisfactory results" },
    { name: "Payment disputes", key: "Payment disputes" },
    { name: "Relocation", key: "Relocation" },
    { name: "Other", key: "Other" },
  ],

  CLIENT_STATUS:[
    { key: "Member", value: "Client" },
    { key: "Non-Member", value: "ClientNonMember" }
  ],

  DEFAULT_EMAIL_TEMPLATE : {
    "counters": {
      "u_column": 1,
      "u_row": 1,
      "u_content_text": 1
    },
    "body": {
      "rows": [
        {
          "cells": [1],
          "columns": [
            {
              "contents": [
                {
                  "type": "text",
                  "values": {
                    "containerPadding": "10px",
                    "text": "<p style=\"text-align: center;\">Hello, this is a basic text block!</p>",
                    "fontFamily": {
                      "label": "Arial",
                      "value": "arial,helvetica,sans-serif"
                    },
                    "fontSize": "14px",
                    "lineHeight": "1.5",
                    "textAlign": "center",
                    "color": "#000000"
                  }
                }
              ],
              "values": {
                "backgroundColor": "#ffffff",
                "padding": "10px"
              }
            }
          ],
          "values": {
            "backgroundColor": "#f0f0f0",
            "padding": "20px"
          }
        }
      ],
      "values": {
        "backgroundColor": "#ffffff",
        "contentWidth": "600px",
        "contentAlign": "center"
      }
    }
  }

};


export const CORPORATE_CONFIG_DETAILS = {
  "Emails": [""],
  "SMS": [""],
  "WhatsApp": ["9717159967"],
};
